export default __webpack_public_path__ + "static/media/interview02_1.ec68da67.jpg";